import { render, staticRenderFns } from "./kuranFloorMenuItem.vue?vue&type=template&id=3f9084b6"
import script from "./kuranFloorMenuItem.vue?vue&type=script&lang=js"
export * from "./kuranFloorMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports